import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EscrowAccountsService {
  private readonly escrowUrl = environment.main_url + '/agilelegal/disbursement/escrow/account';

  constructor(private readonly http: HttpClient) {}

  getEscrowAccounts(pageNumber?: number, pageSize?: number, payload?: any) {
    if (pageNumber && pageSize && payload) {
      return this.http.post<any>(
        `${this.escrowUrl}/filter?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        payload
      );
    }else{
      payload={filters:[],sort:[]}
    }
    // Default case if no pagination or payload is provided
    return this.http.post<any>(`${this.escrowUrl}/filter`,payload);
  }

  saveEscrowAccount(payload: any, id?: number) {
    if (id) {
      // For update, use PUT with id in URL
      return this.http.put<any>(`${this.escrowUrl}/${id}`, payload);
    }
    // For create, use POST without id
    return this.http.post<any>(this.escrowUrl, payload);
  }
  
  deleteEscrowAccount(id: number) {
    // Use DELETE to activate/inactivate
    return this.http.delete<any>(`${this.escrowUrl}/${id}`);
  }
}
